module.exports = __webpack_public_path__ + "img/Jocom.f73422c5.png";